import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router, } from '@angular/router';

import * as firebase from 'firebase/app';
import { AngularFireAuth, PERSISTENCE } from '@angular/fire/auth';
import { AngularFireDatabase } from '@angular/fire/database';

import { CarouselConfig } from 'ngx-bootstrap/carousel';


@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss'],
  providers: [
    { provide: CarouselConfig, useValue: { interval: 3000, noPause: false, showIndicators: false } }
  ]
})
export class SigninComponent implements OnInit {
  @ViewChild("email") emailField: ElementRef;

  emailFormControl = new FormControl('', [
    Validators.required
  ]);
  passwordFormControl = new FormControl('', [
    Validators.required
  ]);
  
  isAuthenticating = false;
  // 'info', 'success', 'warning', 'danger'
  alertType = '';
  alertMsg = '';
  showAlert = false;
  constructor(public afAuth: AngularFireAuth, 
    public db: AngularFireDatabase,
    private router: Router) { }

  ngOnInit() {
    
  }

  ngAfterViewInit()  {
    this.emailField.nativeElement.focus();
  }

  async signin() {
    
    this.isAuthenticating = true;
    if (!this.emailFormControl.valid) {
      this.isAuthenticating = false;
      return;
    }
    let email = this.emailFormControl.value;
    let password = this.passwordFormControl.value;
    
    this.afAuth.setPersistence(firebase.default.auth.Auth.Persistence.LOCAL).then(()=>{
      this.afAuth
      .signInWithEmailAndPassword(email, password)
      .then(value => {
        localStorage.setItem('currentUser', JSON.stringify(value));
        this.isAuthenticating = false;
        this.showAlert = true;
        this.alertType = 'success';
        this.alertMsg = 'Great! Weave your word magic now.';
        this.afAuth.currentUser.then((user)=> {
          if (!user.emailVerified) {
            this.isAuthenticating = false;
            this.showAlert = true;
            this.alertType = 'danger';
            this.alertMsg = 'Please verify your email to continue.';
            return;
          }
          if (!user.displayName) {
            user.updateProfile({
              displayName: email,
              photoURL: ''
            }).then(function(response) {
              //Success
            }, function(error) {
              //Error
              console.log(error);
            });
          }
        });
        this.router.navigate(['/projects']);
      })
      .catch(err => {
        this.isAuthenticating = false;
        this.showAlert = true;
        this.alertType = 'danger';
        this.alertMsg = 'Sorry! Could not successfully sign you in. Please try after sometime or contact support';
      });
    }).catch((error)=>{
      console.log(error);
    });
    
  }

  onAlertClosed(alert) {
    this.showAlert = false;
  }
}
